import { render, staticRenderFns } from "./SpeakerAvatar.vue?vue&type=template&id=5959bf2b&scoped=true&"
import script from "./SpeakerAvatar.vue?vue&type=script&lang=js&"
export * from "./SpeakerAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerAvatar.vue?vue&type=style&index=0&id=5959bf2b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5959bf2b",
  null
  
)

export default component.exports